export default __webpack_public_path__ + "static/media/ss-domi.aed127d6.jpg";